import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import TVuetify from 'vuetify/types'
import pt from 'vuetify/lib/locale/pt'

export function installVuetify() {
  if (Vue.prototype.$vuetify) {
    console.warn('Vuetify já está instalado. Evitando instalação duplicada.')
    return
  }
  Vue.use(Vuetify)
}

/**
 * Cria uma instância do Vuetify já configurada com o whitelabel.
 * @param {object} whitelabel - Objeto de customização da marca (deve conter .ui_customizations)
 * @returns {Vuetify}
 */
let vuetifyInstance: TVuetify | null = null
export function createVuetifyInstance(whitelabel): TVuetify {
  vuetifyInstance = new Vuetify({
    lang: {
      locales: { pt },
      current: 'pt'
    },
    icons: {
      iconfont: 'mdi'
    },
    theme: {
      options: {
        customProperties: true
      },
      themes: {
        light: {
          primary: whitelabel.ui_customizations.primaryColor,
          secondary: whitelabel.ui_customizations.secondaryColor,
          accent: whitelabel.ui_customizations.accentColor,
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        }
      }
    }
  })

  return vuetifyInstance
}

/**
 * Retorna a instância do Vuetify criada.
 * @returns {Vuetify}
 */
export function getVuetifyInstance() {
  if (!vuetifyInstance) {
    throw new Error('Vuetify instance not created. Call createVuetifyInstance first.')
  }
  return vuetifyInstance
}
